import { Shield, Zap, BarChart3, Cloud } from "lucide-react";
import { Card } from "@/components/ui/card";

const Features = () => {
  const features = [
    {
      icon: Zap,
      title: "Cost Reduction",
      description: "Reduce operational costs by up to 40% with automated, intelligent voice interactions that scale infinitely without additional staffing.",
    },
    {
      icon: BarChart3,
      title: "Efficiency & Scale",
      description: "Handle unlimited concurrent conversations with zero wait times. Scale from hundreds to millions of interactions seamlessly.",
    },
    {
      icon: Shield,
      title: "Human-like Conversations",
      description: "Advanced NLP and generative AI deliver natural, contextual conversations that understand intent and sentiment in real-time.",
    },
    {
      icon: Cloud,
      title: "Enterprise Compliance",
      description: "ISO 27001, GDPR-ready, SOC 2, and EU AI Act compliant. Enterprise-grade security and data protection built-in.",
    },
  ];

  return (
    <section className="py-24 bg-secondary/30">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16 animate-fade-in">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">Why Holionix?</h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Enterprise-grade AI voice agents built for scale, security, and seamless integration.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <Card
              key={index}
              className="p-8 hover:shadow-lg transition-all duration-300 hover:-translate-y-1 bg-card border-border"
            >
              <div className="w-14 h-14 rounded-lg bg-accent/10 flex items-center justify-center mb-6">
                <feature.icon className="w-7 h-7 text-accent" />
              </div>
              <h3 className="text-xl font-semibold mb-3 text-card-foreground">{feature.title}</h3>
              <p className="text-muted-foreground leading-relaxed">{feature.description}</p>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
